<div class="segment-scrub-bars">
  <div class="w-full flex gap-2 scrub-bars">
    @for (sbs of scrubBarSegments(); track sbs.index) {
      <div class="scrub-bar-wrapper" [ngStyle]="{'flex-basis': sbs.percOfTotal + '%'}">
        <button (click)="mediaClickedEvent(sbs.index)" class="scrub-bar w-full" [title]="segmentLabel(sbs)" [aria-label]="segmentLabel(sbs)">
          <div class="py-2 hover:bg-default-200 rounded-full">
            <div class="progress-container">
              <div class="progress-position" [ngStyle]="{'width': sbs.percPlayed + '%'}"></div>
            </div>
          </div>
        </button>
      </div>
    }
  </div>
</div>
